import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { Divider, List, ListItem, ListItemText } from "@mui/material";

function Menu({ isMobile, menuButtonClick }) {
  return (
    <>
      <List>
        <Link
          to="/?isValidated=false?page=1?perPage=10"
          onClick={isMobile ? menuButtonClick : ""}
          style={{ textDecoration: "none" }}
        >
          <ListItem button>
            <ListItemText style={{ color: "black" }} primary="Formulare" />
          </ListItem>
        </Link>
        <Divider style={{ background: "black", opacity: 0.2 }} />
        <Link
          to="/reports"
          onClick={isMobile ? menuButtonClick : ""}
          style={{ textDecoration: "none" }}
        >
          <ListItem button>
            <ListItemText
              style={{ color: "black" }}
              primary="Generare rapoarte"
            />
          </ListItem>
        </Link>
        <Divider style={{ background: "black", opacity: 0.2 }} />
        <Link
          to="/users"
          onClick={isMobile ? menuButtonClick : ""}
          style={{ textDecoration: "none" }}
        >
          <ListItem button>
            <ListItemText style={{ color: "black" }} primary="Utilizatori" />
          </ListItem>
        </Link>
        <Divider style={{ background: "black", opacity: 0.2 }} />
        <Link
          to="/forms"
          onClick={menuButtonClick}
          style={{ textDecoration: "none" }}
        >
          <ListItem button>
            <ListItemText
              style={{ color: "black" }}
              primary="Adăugați un nou formular"
            />
          </ListItem>
        </Link>
        <Divider style={{ background: "black", opacity: 0.2 }} />
      </List>
    </>
  );
}
export default Menu;

Menu.propTypes = {
  isMobile: PropTypes.bool,
  menuButtonClick: PropTypes.func,
};
